import { render } from "./DeviceDetailsPage.vue?vue&type=template&id=1b54f6b6&scoped=true"
import script from "./DeviceDetailsPage.vue?vue&type=script&lang=js"
export * from "./DeviceDetailsPage.vue?vue&type=script&lang=js"

import "./DeviceDetailsPage.vue?vue&type=style&index=0&id=1b54f6b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b54f6b6"]])

export default __exports__